import DeviantsSearchButton from './DeviantsSearchButton';
import DeviantsSearchButtonContainer from './DeviantsSearchButton.container';

export default DeviantsSearchButtonContainer(DeviantsSearchButton);
